// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"02b2f44f","453":"d3630b90","667":"9f00a38e"}[chunkId] + ".chunk.js";
};